<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="notifications.data"
		:excel="isButton_(scrId, 'EX')"
		index
		selection
		paging
		@changedPage="onChangePage"
		:currentPage="notifications.currentPage"
		:pageUnit="notifications.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="notifications.totalSize"
	>
		<template v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="deleteAction">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/Notification/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...serviceComputed,
		...rootComputed,

		columns() {
			return [
				{
					label: this.getMessage_('SWCC000519') /**제목 */,
					prop: 'notiTitle',
					minWidth: '300px',
					clickEvent: this.onClickRow,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000520') /**내용 */,
					prop: 'notiContent',
					minWidth: '500px'
				},
				{
					label: this.getMessage_('SWCC000145') /**사용유무 */,
					prop: 'useYn',
					minWidth: '150px'
				},
				{ label: this.getMessage_('SWCC000005') /**등록자 */, prop: 'regId', minWidth: '150px' },
				{ label: this.getMessage_('SWCC000146') /**등록일 */, prop: 'dRegDt', minWidth: '180px' },
				{ label: this.getMessage_('SWCC000172') /**수정자 */, prop: 'chgId', minWidth: '150px' },
				{ label: this.getMessage_('SWCC000171') /**수정일 */, prop: 'dChgDt', minWidth: '180px' }
			];
		}
	},
	methods: {
		...serviceMethods,
		...rootMethods,

		//선택된 Rows 정보
		getSelectedRows() {
			return this.$refs.table.getSelectedRows();
		},

		//페이징 정보 변경 이벤트
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.search({ currentPage: currentPageVal, pageUnit: pageUnitVal });
		},

		//공지사항 조회
		search({ currentPage, pageUnit }) {
			this.$sf_toggleLoading(true);
			this.select_({
				...this.searchParams,
				currentPage,
				pageUnit
			})
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//Row 클릭하여 모달창 열기
		onClickRow(row) {
			this.setState_({ key: 'notificationsModal', value: { opened: true, ...row } });
		},

		//삭제 버튼 클릭
		deleteAction() {
			if (this.getSelectedRows().length === 0) {
				this.$sf_showMessage({
					icon: 'error',
					message: this.getMessage_('SWCC000109') /**행을 선택해 주세요. */
				});
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000108') /**삭제하시겠습니까? */,
				buttons: [{ title: this.getMessage_('SWCC000107') /**삭제 */, clickFn: this.delete }]
			});
		},

		//삭제 Action 호출
		async delete() {
			const rows = this.getSelectedRows();

			this.$sf_toggleLoading(true);
			await this.delete_(rows)
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
